import config from 'constants/config'
import { destinationsMap } from 'constants/experience'
import { getSearchItemDestinationId } from 'lib/search/searchItem'

const EXPERIENCE_DESTINATION_ALIASES: Record<string, string> = {
  'city of perth': 'perth',
  'melbourne city': 'melbourne',
  'city of melbourne': 'melbourne',
  'council of the city of sydney': 'sydney',
  'city of sydney': 'sydney',
}

const EXPERIENCE_DESTINATION_SECONDARY_TEXT: Record<string, string> = {
  'gold coast': 'City · Queensland, Australia',
  melbourne: 'City · Victoria, Australia',
  perth: 'City · Western Australia, Australia',
  sydney: 'City · New South Wales, Australia',
}

function normaliseDestinationName(value: string) {
  return value.trim().toLowerCase().replace(/\s+/g, ' ')
}

const EXPERIENCE_CANONICAL_PLACE_ID_BY_NAME = Object.fromEntries(
  destinationsMap(config.BRAND).flatMap((destination) => {
    const canonicalName = normaliseDestinationName(destination.destinationKey)
    if (!(canonicalName in EXPERIENCE_DESTINATION_SECONDARY_TEXT)) {
      return []
    }

    return [[canonicalName, destination.id]]
  }),
)

export function getCanonicalExperienceDestination(searchPhrase: string): App.SearchDestination | undefined {
  const normalisedSearchPhrase = normaliseDestinationName(searchPhrase)
  const canonicalName = EXPERIENCE_DESTINATION_ALIASES[normalisedSearchPhrase] ?? normalisedSearchPhrase

  if (!(canonicalName in EXPERIENCE_DESTINATION_SECONDARY_TEXT)) return undefined

  const placeId = EXPERIENCE_CANONICAL_PLACE_ID_BY_NAME[canonicalName]
  if (!placeId) return undefined

  return {
    searchType: 'destination',
    value: placeId,
    format: {
      mainText: searchPhrase.trim(),
      secondaryText: EXPERIENCE_DESTINATION_SECONDARY_TEXT[canonicalName],
    },
  }
}

export function prependCanonicalExperienceDestination(
  searchResults: Array<App.SearchItem>,
  searchPhrase: string,
  vertical?: App.SearchPlaceVertical,
) {
  if (vertical !== 'experience' || searchPhrase.length < 2) return searchResults

  const canonicalDestination = getCanonicalExperienceDestination(searchPhrase)
  if (!canonicalDestination) return searchResults

  const matchingIndex = searchResults.findIndex(item => getSearchItemDestinationId(item) === canonicalDestination.value)
  if (matchingIndex >= 0) {
    const matchingItem = searchResults[matchingIndex]
    return [matchingItem, ...searchResults.filter((_, index) => index !== matchingIndex)]
  }

  return [canonicalDestination, ...searchResults]
}
